import { sessionHeaders } from './sessionStorage';
import { COLLA, getServerEndpoint } from './utils';

export function sessionFetch(url, options = {}) {
    const target = new URL(url, window.location.href);
    const backend = new URL(getServerEndpoint(COLLA));
    const authenticated = target.origin === backend.origin
        && (target.pathname.startsWith('/api/') || target.pathname === '/auth/verify_password');
    const authorization = authenticated ? sessionHeaders() : {};
    return fetch(url, {
        ...options,
        headers: { ...options.headers, ...authorization },
        ...(authorization.Authorization ? { redirect: 'error' } : {}),
    });
}
